var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: { "is-disabled": _vm.isDisabled },
      attrs: { "data-component": "base-item-actions-inline" },
    },
    [
      !_vm.showActionIcons && _vm.actions.length
        ? _c(
            "div",
            { staticClass: "actions" },
            _vm._l(_vm.actions, function (action) {
              return _c(
                "div",
                {
                  key: action.key,
                  attrs: { "data-button": action.key },
                  on: {
                    click: function ($event) {
                      return _vm.onActionClick(action.key)
                    },
                  },
                },
                [_vm._v("\n      " + _vm._s(action.label) + "\n    ")]
              )
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showActionIcons && _vm.actions.length
        ? _c(
            "div",
            { staticClass: "action-icons" },
            _vm._l(_vm.actions, function (action) {
              return _c("base-icon-button", {
                key: action.key,
                attrs: {
                  "data-button": action.key,
                  icon: action.icon,
                  color: action.color || "primary",
                  "is-disabled": _vm.isDisabled,
                },
                on: {
                  click: function ($event) {
                    return _vm.onActionClick(action.key)
                  },
                },
              })
            }),
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.description && !_vm.showActionIcons
        ? _c("div", { staticClass: "description" }, [
            _vm._v("\n    " + _vm._s(_vm.description) + "\n  "),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }